<template>
    <ProgressSpinner v-if="!manufacturer"/>
    <Container class="pt-6" v-if="manufacturer">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>{{ manufacturer.name ?? $route.params.manufacturer }}</PageHeading>
        </div>

	    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
        <TabLayout :tabs="tabs" sticky/>
	    </div>

        <router-view
		        @on-save="$emit('on-save')"
		        @on-delete="$emit('on-delete')"
		        :manufacturer="manufacturer"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useDeviceManufacturersStore } from "@/stores/deviceManufacturers.js";
import Container from "@/Components/Container.vue";


export default {
    name: "DeviceManufacturerView",
    components: {Container, TabLayout, PageHeading},
    data() {
        return {
            manufacturer: undefined,
        }
    },
    emits: [
        'on-save',
		    'on-delete',
    ],
    watch: {
        '$route.params.manufacturer': {
            async handler(newValue, oldValue) {
                if(newValue){
                    this.manufacturer = undefined;
                    if(this.$route.params.manufacturer === 'NEW'){
                        this.manufacturer = {};
                    } else {
                        this.manufacturer = await this.deviceManufacturersStore.showDeviceManufacturer( this.$route.params.manufacturer);
                    }
                } else {
                    this.manufacturer = undefined;
                }
            },
            immediate: true,
        }
    },
    computed: {
        ...mapStores(useDeviceManufacturersStore),
        tabs() {
            return [
                {
                    label: this.$t('common.properties'),
                    current: this.$route.name === 'admin.devices.manufacturers.manufacturer',
                    to: {name: 'admin.devices.manufacturers.manufacturer', params: this.$route.params}
                },
            ]
        }
    },
}
</script>
